import { DeleteButton, SaveButton } from "@/components/admin";
import { Card } from "@/components/ui/card";
import { Calculator } from "lucide-react";
import {
  BooleanInput,
  Edit,
  NumberInput,
  SelectInput,
  SimpleForm,
  TextInput,
} from "../../common";

const typeChoices = [
  { id: "earning", name: "Earning" },
  { id: "deduction", name: "Deduction" },
];
const calculationChoices = [
  { id: "fixed", name: "Fixed" },
  { id: "percent_of_basic", name: "Percent of Basic" },
  { id: "formula", name: "Formula" },
];

const ComponentEditToolbar = () => (
  <div className="form-toolbar-premium">
    <DeleteButton className="btn-delete-action" />
    <SaveButton className="btn-green-action" label="Update Component" />
  </div>
);

export const PayrollComponentEdit = () => (
  <Edit title="Edit Payroll Component" actions={false}>
    <Card className="form-container">
      <div className="form-header-premium">
        <Calculator className="w-6 h-6 text-emerald-600" />
        <h2 className="text-2xl font-bold text-slate-900">Edit Payroll Component</h2>
      </div>
      <SimpleForm toolbar={<ComponentEditToolbar />}>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <TextInput source="code" label="Component Code" />
          <TextInput source="name" label="Component Name" />
          <SelectInput source="type" choices={typeChoices} />
          <SelectInput source="calculation" choices={calculationChoices} />
          <NumberInput source="value" label="Value / Percentage" />
          <NumberInput source="sort_order" label="Display Order" />
        </div>
        <div className="mt-4">
          <BooleanInput source="taxable" label="Is Taxable?" />
        </div>
      </SimpleForm>
    </Card>
  </Edit>
);
